import { html, nothing } from 'lit';
import type { ChatExtras, VisitorInfo } from '../../core';
import type { ChatStrings } from '../strings';

export type PrechatConfig = NonNullable<ChatExtras['prechat']>;
export interface PrechatDraft { name: string; phone: string }
export const prechatAsked = (c: PrechatConfig | undefined): c is PrechatConfig => !!c && c.enabled && (c.askName || c.askPhone);

/** Returns the visitor to submit, or the string key of the first problem. */
export function validatePrechat(c: PrechatConfig, d: PrechatDraft): { ok: true; info: VisitorInfo } | { ok: false; error: 'prechatNameRequired' | 'prechatPhoneRequired' | 'prechatPhoneInvalid' } {
  const name = d.name.trim(), phone = d.phone.trim(), info: VisitorInfo = {};
  if (c.askName) { if (!name) return { ok: false, error: 'prechatNameRequired' }; info.name = name; }
  if (c.askPhone) {
    if (!phone) { if (c.phoneRequired) return { ok: false, error: 'prechatPhoneRequired' }; }
    else if (!/^\+?[0-9 ()\-.]+$/.test(phone) || phone.replace(/\D/g, '').length < 7 || phone.replace(/\D/g, '').length > 15) return { ok: false, error: 'prechatPhoneInvalid' };
    else info.phone = phone;
  }
  return { ok: true, info };
}

export interface PrechatOptions { strings: ChatStrings; config: PrechatConfig; draft: PrechatDraft; error: string | null; input: (field: keyof PrechatDraft, value: string) => void; submit: () => void }
export function renderPrechat(o: PrechatOptions) {
  const field = (name: keyof PrechatDraft, type: string, label: string, auto: string) => html`<label>${label}<input name=${name} type=${type} autocomplete=${auto} .value=${o.draft[name]} @input=${(e: Event) => o.input(name, (e.target as HTMLInputElement).value)}></label>`;
  return html`<form class="prechat" novalidate @submit=${(e: Event) => { e.preventDefault(); o.submit(); }}><p>${o.strings.prechatIntro}</p>
    ${o.config.askName ? field('name', 'text', o.strings.prechatName, 'name') : nothing}
    ${o.config.askPhone ? field('phone', 'tel', o.config.phoneRequired ? o.strings.prechatPhone : o.strings.prechatPhoneOptional, 'tel') : nothing}
    ${o.error ? html`<div class="prechat-error" role="alert">${o.error}</div>` : nothing}
    <button type="submit" class="prechat-go">${o.strings.prechatStart}</button></form>`;
}
